<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-card v-on="on">
        <v-card-subtitle
          :class="(plus?'idcs-t-buy':'idcs-t-sell') +' font-weight-black'"
        >{{plus?$t('field.amount1.'+$store.getters.iface):$t('field.amount2.'+$store.getters.iface)}}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="summary-amt d-flex justify-center align-center">
              <v-icon>mdi-sigma</v-icon>
              <!-- <span>{{$t('field.amount1')}}</span>!-->
              <span class="ml-2 summ-data">{{total | currency}}</span>
            </v-col>
            <v-col cols="6" class="summary-avg d-flex justify-center align-center">
              <v-icon small>fa-chart-line</v-icon>
              <span class="ml-2 summ-data">{{avg | currency}}</span>
            </v-col>
            <v-col cols="6" class="summary-cnt d-flex justify-center align-center">
              <v-icon small>fa-shopping-cart</v-icon>
              <span class="ml-2 summ-data">{{count}}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <div>
      <div class="my-2">
        <v-icon dark class="mr-4">mdi-sigma</v-icon>
        <span>{{$t('summary.tt.total')}}</span>
      </div>
      <div class="my-2">
        <v-icon dark class="mr-4">fa-chart-line</v-icon>
        <span>{{$t('summary.tt.avg')}}</span>
      </div>
      <div class="my-2">
        <v-icon dark class="mr-4">fa-shopping-cart</v-icon>
        <span>{{$t('summary.tt.count')}}</span>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "SummaryBlock",
  props: {
    plus: {
      type: Boolean,
      default() {
        return false;
      }
    },
    total: { type: Number },
    avg: { type: Number },
    count: { type: Number }
  }
};
</script>

<style scoped>
.summ-data {
  color: coral;
  font-size: large;
}
</style>